import React from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, Menu, Button } from 'antd';
import { MoreOutlined } from '@ant-design/icons';

export type Action = {
  label: string;
  icon?: string;
  actionType: 'link' | 'modal';
  to?: string;
  onClick?: () => void;
  hidden?: boolean;
};

interface ActionsDropdownProps {
  actions: Action[];
}

const ActionsDropdown: React.FC<ActionsDropdownProps> = ({ actions }) => {
  const menu = (
    <Menu>
      {actions
        .filter((action) => !action.hidden)
        .map((action, idx) => (
          <Menu.Item
            key={idx}
            icon={action.icon ? <i className={`${action.icon} me-2`} /> : undefined}
            onClick={action.actionType === 'modal' ? action.onClick : undefined}
          >
            {action.actionType === 'link' ? (
              <Link to={action.to || '#'} onClick={action.onClick}>
                {action.label}
              </Link>
            ) : (
              action.label
            )}
          </Menu.Item>
        ))}
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={['click']}
      placement="bottomRight"
    >
      <Button
        type="text"
        icon={<MoreOutlined />}
        size="small"
        style={{ padding: 0 }}
      />
    </Dropdown>
  );
};

export default ActionsDropdown;
